import CreateInvestorGoalError from './CreateInvestorGoalError';
export default CreateInvestorGoalError;
